import clsx from 'clsx'
import BaseText, { TextProps as BaseTextProps } from 'antd/lib/typography/Text'

export interface TextProps extends BaseTextProps {
  mute?: boolean
}

export const Text = ({ mute, ...rest }: TextProps): JSX.Element => (
  <>
    <BaseText {...rest} className={clsx({ 'text-gray-400': mute })} />
  </>
)
